import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject,
  Input,
  Optional,
} from '@angular/core';
import {TisaArticle, TisaCategory} from '@tisa-group/client-ui/models';
import {
  TISA_VIEW_ARTICLE_PATH,
  TISA_VIEW_CATEGORY_PATH,
} from '@tisa-group/client-ui/tokens';

@Component({
  selector: 'tisa-article-block',
  templateUrl: './article-block.component.html',
  styleUrls: ['article-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ArticleBlockComponent {
  @HostBinding('class')
  readonly className = 'grid grid-rows-[1fr,40px,180px] bg-white-500 overflow-hidden';

  get link(): string | undefined {
    if (this.article?.slug) {
      return this.viewArticlePath + this.article.slug;
    }

    return undefined;
  }

  get isPremium(): boolean | undefined {
    return this.article?.isPremium;
  }

  get categoryLink(): string | undefined {
    if (this.category?.slug) {
      return this.viewCategoryPath + this.category.slug;
    }

    return undefined;
  }

  @Input()
  article: TisaArticle | undefined;

  category: TisaCategory | undefined;

  constructor(
    @Optional()
    @Inject(TISA_VIEW_ARTICLE_PATH)
    readonly viewArticlePath: string | undefined,
    @Optional()
    @Inject(TISA_VIEW_CATEGORY_PATH)
    readonly viewCategoryPath: string | undefined,
  ) {}
}
